<template>
    <!--
    <div>
        <div
            id="carouselExampleControls"
            class="carousel slide carousel-fade"
            data-ride="carousel"
        >
            <div class="carousel-inner">
                <div class="carousel-item active">
                    <img
                        class="d-block w-100"
                        src="@assets/images/teens-on-phones.jpg"
                        alt="First slide"
                    />
                </div>
                <div class="carousel-item">
                    <img
                        class="d-block w-100"
                        src="@assets/images/grandma-with-phone.jpg"
                        alt="Second slide"
                    />
                </div>
            </div>
            <a
                class="carousel-control-prev"
                href="#carouselExampleControls"
                role="button"
                data-slide="prev"
            >
                <span
                    class="carousel-control-prev-icon"
                    aria-hidden="true"
                ></span>
                <span class="sr-only">Previous</span>
            </a>
            <a
                class="carousel-control-next"
                href="#carouselExampleControls"
                role="button"
                data-slide="next"
            >
                <span
                    class="carousel-control-next-icon"
                    aria-hidden="true"
                ></span>
                <span class="sr-only">Next</span>
            </a>
        </div>

        <div class="normal-container py-5">
            <h1 class="text-center">
                A Mobile Device Option That Keeps You Connected To The Most
                Vulnerable...
            </h1>
            <h2
                class="text-center card-subtitle text-color-aoa-red font-weight-bold"
            >
                While Avoiding The Psychological Dangers of Social Media And Predatorial Exposure
            </h2>
            <div class="row mt-3 pt-1 mx-2 mx-md-3 text-center">
                <div class="col-6 col-sm-3">
                    <div class="text-center no-wrap icon-text">Text Messaging</div>
                    <img
                        class="d-block w-75 m-auto"
                        src="@assets/images/message-icon.png"
                        alt="Message Icon"
                    />
                </div>
                <div class="col-6 col-sm-3">
                    <div class="text-center no-wrap icon-text">Audio Calling</div>
                    <img
                        class="d-block w-75 m-auto"
                        src="@assets/images/audio-icon.png"
                        alt="Audio Icon"
                    />
                </div>
                <div class="col-6 col-sm-3">
                    <div class="text-center no-wrap icon-text">Video Calling</div>
                    <img
                        class="d-block w-75 m-auto"
                        src="@assets/images/video-icon.png"
                        alt="Video Icon"
                    />
                </div>
                <div class="col-6 col-sm-3">
                    <div class="text-center no-wrap icon-text">GPS Tracking</div>
                    <img
                        class="d-block w-75 m-auto"
                        src="@assets/images/gps-icon.png"
                        alt="GPS Icon"
                    />
                </div>
            </div>
            <div v-if="isAuthenticated" class="text-center py-5">
                <router-link
                    class="btn btn-lg btn-lg-rounded schedule-now"
                    :to="{ name: 'ao-armor.messaging.index' }"
                >
                    Open AOArmor
                </router-link>
            </div>

            <testimonial class="mx-1 mx-lg-3"></testimonial>
        </div>
    </div>
    -->
    <main class="center-page">
        <img
            src="@assets/images/AOlogo-long.png"
            alt="Logo"
            class="logo"
        />
        <h6></h6>
        <h1 class="mt-4">Our website is under construction. We'll have more for you soon!</h1>
        <p>- The AOarmor Team</p>
    </main>
</template>
<script>
import { routing } from '@/mixins/routing';
import { mapActions, mapGetters } from 'vuex';
import { sizing } from '@/mixins/sizing';

export default {
    mixins: [routing, sizing],
    data() {
        return {
            BREAKPOINT_SMALL: 578, // This is different from the data file value
        };
    },
    computed: {
        ...mapGetters('Auth', ['isAuthenticated']),
        ...mapGetters('Facility', ['preferredFacility']),
    },
    created() {
        const token = this.queryParams.get('token');
        const service = this.queryParams.get('service');
        this.removeStorage(); // The pushToken that could have been set previously is not removed

        if (token && service) {
            this.setupPushService(token, service);
        }

        if (this.isAuthenticated) {
            this.userRequest().then(() => {
                this.$router.push({
                    name: 'ao-armor.messaging.index',
                });
            });
        }
    },
    methods: {
        ...mapActions('User', ['userRequest']),

        setupPushService(pushToken, pushService) {
            if (!pushToken || !pushService) return;

            // These are any previous tokens we've stored for this device.
            let previous = localStorage.getItem('pushToken');

            if (previous) {
                if (previous === pushToken) {
                    // The token has not changed. Touch the DB record.
                    localStorage.setItem('pushAction', 'touch');
                    localStorage.setItem('pushService', pushService);
                } else {
                    // Then the token has refreshed.
                    localStorage.setItem('newToken', pushToken);
                    localStorage.setItem('pushService', pushService);
                    localStorage.setItem('pushAction', 'update');
                }
            } else {
                localStorage.setItem('pushToken', pushToken);
                localStorage.setItem('pushService', pushService);
                localStorage.setItem('pushAction', 'store');
            }
        },
        removeStorage() {
            localStorage.removeItem('newToken');
            localStorage.removeItem('pushAction');
            localStorage.removeItem('pushService');
        },
    },
};
</script>

<style scoped>
.icon-text {
    font-size: 100%;
}

@media screen and (max-width: 1199px) {
    .icon-text {
        font-size: 80%;
    }
}

@media screen and (max-width: 991px) {
    .icon-text {
        font-size: 65%;
    }
}

@media screen and (max-width: 767px) {
    .icon-text {
        font-size: 75%;
    }
}

@media screen and (max-width: 575px) {
    .icon-text {
        font-size: 100%;
    }
}

/** Temp CSS */
html, body {
    height: 100%;
}
body {
    background-color: #fff;
    background: radial-gradient(circle at center, #fff 0%, #f8f8f8 75%, #ebebeb 100%);
    color: #222;
    font-family: system-ui, -apple-system, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", "Liberation Sans", sans-serif;
    font-size: 1rem;
    line-height: 1.5;
    margin: 0;
    display: flex;
    justify-content: center;
    align-items: center;
}
main {
    padding: 1rem;
    text-align: center;
}
h1 {
    font-size: 2rem;
    line-height: 1.1;
    margin: 0;
}
@media screen and (max-width: 480px) {
    h1 {
        font-size: 1.5rem;
    }
}
h6::before {
    content: "";
    background-color: #ffe800;
    background: repeating-linear-gradient(45deg, #ffe800, #ffe800 0.5rem, #222 0.5rem, #222 1.0rem);
    display: block;
    height: 0.5rem;
    margin-top: 1rem;
}
img {
    max-width: 100%;
    height: auto;
}
p {
    margin: 1rem 0 0 0;
}
</style>